export function objectWithoutTypename<T extends Record<string, unknown>>(object: T) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { __typename, ...data } = object;
    return data;
}
